import React, {ReactNode, useCallback, useEffect, useRef, useState} from "react"
import Styles from "./dataList.less"
import {connect, useDispatch} from "react-redux"
import {UseImageList, UseListData} from "../../../../../function/hooks/useDataFromRedux"
import noContentListDataSvg from "../../../../../static/pic/noContentListData.svg"
import classNames from "classnames"
import {debounce, isElement} from "lodash-es"
import {ReducerState} from "../../../../../reducer/interface/baseInterface"
import {ContentItem, ListJump, LocationShape, ShapeFromPos} from "../../../../../reducer/interface/dataInterface"

const chooseColor = (type: string) => {
    switch (type) {
        case "replace":
            return "rgba(35,134,238, 0.2)"
        case "delete":
            return "rgba(253,194,0, 0.2)"
        case "insert":
            return "rgba(27,168,84, 0.2)"
        default:
            return ""
    }
}

const getBorder = (data: ContentItem, hoverItem: ContentItem | null, type: string) => {
    if (hoverItem && data.diffIndex === hoverItem.diffIndex) {
        switch (type) {
            case "replace":
                return {
                    border: "1px solid #276ff5",
                    boxShadow: "0 0 8px 2px  rgba(39, 111, 245, 0.5)",
                }
            case "delete":
                return {
                    border: "1px solid #ff991c",
                    boxShadow: "0 0 8px 2px  rgba(255, 153, 28, 0.5)",
                }
            case "insert":
                return {
                    border: "1px solid #0ca43e",
                    boxShadow: "0 0 8px 2px  rgba(12, 164, 62, 0.5)",
                }
            default:
        }
    }
}

interface DataListProps {
    type: string
    onSetNum: (item: number) => void
    shapeFromPos: ShapeFromPos | null
    hoverItem: ContentItem | null
    pageJump: any
}
const DataList: React.FunctionComponent<DataListProps> = (props) => {
    const dispatch = useDispatch()
    const dataListRef = useRef<HTMLDivElement>(null)
    const listData = UseListData()
    const listHoverSelect = (item: ContentItem) => {
        dispatch({type: "changeHoverDiffitem", payload: item})
    }
    // const dobounce = (fn: Function, time: number) => {
    //     let timer: any
    //     return (...args: any) => {
    //         clearTimeout(timer)
    //         timer = setTimeout(() => {
    //             fn.apply(this, args)
    //         }, time)
    //     }
    // }
    const [contentList, setContentList] = useState<Array<ContentItem>>([])
    const handleListKeyDown = useCallback(
        (e: KeyboardEvent) => {
            e.preventDefault()
            if (e.keyCode === 40) {
                debounce(() => {
                    const index = contentList.findIndex((item) => item.diffIndex === props.hoverItem?.diffIndex)
                    if (index !== -1) {
                        dispatch({type: "changeHoverDiffitem", payload: contentList[index + 1]})
                        pageJump(contentList[index + 1])
                        const dom = document.getElementById(`contentItem${props.pageJump.diffIndex}`)
                        if (dom) {
                            dataListRef.current?.scrollTo &&
                                dataListRef.current?.scrollTo(
                                    0,
                                    dom.offsetTop - dataListRef.current.offsetHeight / 2 + dom.offsetHeight / 2
                                )
                        }
                    }
                }, 200)()
            }
            if (e.keyCode === 38) {
                const index = contentList.findIndex((item) => item.diffIndex === props.hoverItem?.diffIndex)
                if (index !== -1) {
                    debounce(() => {
                        dispatch({type: "changeHoverDiffitem", payload: contentList[index - 1]})
                        pageJump(contentList[index - 1])
                        const dom = document.getElementById(`contentItem${props.pageJump.diffIndex}`)
                        if (dom) {
                            dataListRef.current?.scrollTo &&
                                dataListRef.current?.scrollTo(
                                    0,
                                    dom.offsetTop - dataListRef.current.offsetHeight / 2 + dom.offsetHeight / 2
                                )
                        }
                    }, 200)()
                }
            }
        },
        [contentList, props.hoverItem, dataListRef, props.pageJump]
    )
    useEffect(() => {
        document.addEventListener("keydown", handleListKeyDown)
        return () => {
            document.removeEventListener("keydown", handleListKeyDown)
        }
    }, [handleListKeyDown])
    useEffect(() => {
        const deleteData = listData.delete
        const insertData = listData.insert
        const data = listData.replace
        let resultList: Array<ContentItem> = []
        switch (props.type) {
            case "all":
                resultList = deleteData
                    .concat(insertData)
                    .concat(data)
                    .sort((a, b) => {
                        return a.diffIndex - b.diffIndex
                    })
                break
            case "delete":
                resultList = deleteData.sort((a, b) => {
                    return a.diffIndex - b.diffIndex
                })
                break
            case "replace":
                resultList = data.sort((a, b) => {
                    return a.diffIndex - b.diffIndex
                })
                break
            case "insert":
                resultList = insertData.sort((a, b) => {
                    return a.diffIndex - b.diffIndex
                })
                break
            default:
                resultList = []
        }
        setContentList(resultList)
        props.onSetNum(resultList.length)
    }, [props.type])
    useEffect(() => {
        if (props.pageJump.listJump) {
            const dom = document.getElementById(`contentItem${props.pageJump.diffIndex}`)
            if (dom) {
                twinkle(dom, props.pageJump.diffType)
                dataListRef.current?.scrollTo &&
                    dataListRef.current?.scrollTo(
                        0,
                        dom.offsetTop - dataListRef.current.offsetHeight / 2 + dom.offsetHeight / 2
                    )
            }
        }
    }, [props.pageJump])
    const twinkle = (dom: HTMLElement, type: string) => {
        if (isElement(dom)) {
            setTimeout(() => {
                dom.style.backgroundColor = chooseColor(type)
            }, 0)
            setTimeout(() => {
                dom.style.backgroundColor = "#ffffff"
            }, 200)
            setTimeout(() => {
                dom.style.backgroundColor = chooseColor(type)
            }, 400)
            setTimeout(() => {
                dom.style.backgroundColor = "#ffffff"
            }, 600)
        } else {
            console.error("twinkle函数失效")
        }
    }
    const pageJump = (data: ContentItem) => {
        const pageJumpData = {
            Base: {
                ...props.pageJump.Base,
                jump: false,
                find: true,
                follow: false,
            },
            Compare: {
                ...props.pageJump.Compare,
                jump: false,
                find: true,
                follow: false,
            },
            listJump: false,
            diffType: data.diffType,
            diffIndex: data.diffIndex,
        }
        dispatch({type: "onPageJump", payload: pageJumpData})
    }
    const renderDiffWords = (str: string, diffWords: Array<any>, type: string) => {
        if (diffWords && diffWords.length !== 0) {
            let newNode: any = []
            // let testStr: any = []
            let startIndex = 0
            let words = type === "base" ? "wordsBase" : "wordsCompare"
            let wordsIndex = type === "base" ? "wordsIndexBase" : "wordsIndexCompare"
            diffWords.forEach((item) => {
                if (item[wordsIndex] !== startIndex) {
                    // const testUnDiffWords = str.slice(startIndex, item[wordsIndex])
                    // const testDiffWords = str.slice(item[wordsIndex], item[wordsIndex] + item[words].length)
                    const unDiffWords = <span>{str.slice(startIndex, item[wordsIndex])}</span>
                    const hasDiffWords = (
                        <span className={Styles.diffWords}>
                            {str.slice(item[wordsIndex], item[wordsIndex] + item[words].length)}
                        </span>
                    )
                    // testStr = testStr.concat([testUnDiffWords, testDiffWords])
                    newNode = newNode.concat([unDiffWords, hasDiffWords])
                } else {
                    // const testDiffWords = str.slice(item[wordsIndex], item[wordsIndex] + item[words].length)
                    const hasDiffWords = (
                        <span className={Styles.diffWords}>
                            {str.slice(item[wordsIndex], item[wordsIndex] + item[words].length)}
                        </span>
                    )
                    // testStr = testStr.concat([testDiffWords])
                    newNode = newNode.concat([hasDiffWords])
                }
                startIndex = item[wordsIndex] + item[words].length
            })
            if (startIndex !== str.length) {
                // const testUnDiffWords = str.slice(startIndex, str.length)
                const unDiffWords = <span>{str.slice(startIndex, str.length)}</span>
                // testStr = testStr.concat([testUnDiffWords])
                newNode = newNode.concat([unDiffWords])
            }
            // if (testStr.join("") !== str) {
            //     console.log(testStr.join(""), str, "不相等")
            //     console.log(startIndex, str.length)
            //     console.log(str.slice(startIndex, str.length))
            // }
            return newNode
        } else {
            return <span>{str}</span>
        }
    }
    const renderList = contentList.map((item, index) => {
        switch (item.diffType) {
            case "replace":
                return (
                    <ReplaceItem
                        key={`content${item.diffIndex}`}
                        index={index}
                        onJump={pageJump}
                        onHover={listHoverSelect}
                        hoverItem={props.hoverItem}
                        data={item}
                        renderDiffWords={renderDiffWords}
                    />
                )
            case "delete":
                return (
                    <DeleteItem
                        key={`content${item.diffIndex}`}
                        index={index}
                        onJump={pageJump}
                        onHover={listHoverSelect}
                        hoverItem={props.hoverItem}
                        data={item}
                        renderDiffWords={renderDiffWords}
                    />
                )
            case "insert":
                return (
                    <InsertItem
                        key={`content${item.diffIndex}`}
                        index={index}
                        onJump={pageJump}
                        onHover={listHoverSelect}
                        hoverItem={props.hoverItem}
                        data={item}
                        renderDiffWords={renderDiffWords}
                    />
                )
            default:
                return null
        }
    })
    return (
        <div ref={dataListRef} className={Styles.successBox}>
            {contentList.length === 0 ? <NoDataList type={props.type} /> : renderList}
        </div>
    )
}

const NoDataList: React.FunctionComponent<{type: string}> = ({type}) => {
    return (
        <div className={Styles.noContentList}>
            <img alt={""} style={{width: "280px"}} src={noContentListDataSvg} />
            <div>{type === "all" ? "当前文件暂无比对差异" : "暂无差异"}</div>
        </div>
    )
}

interface ContentItemProps {
    onJump: (data: ContentItem) => void
    onHover: (data: ContentItem) => void
    data: ContentItem
    index: number
    hoverItem: ContentItem | null
    renderDiffWords: (str: string, diffWords: Array<any>, type: string) => ReactNode
}

const calculateContent = (base: any, compare: any) => {
    if (base.length === compare.length) {
        if (base === compare) {
            return []
        } else {
            return createDiffWords(base, compare)
        }
    } else {
        // 判断是否完全包含
        let shortStr = base.length > compare.length ? "compare" : "base"
        let indexOf = base.length > compare.length ? base.indexOf(compare) : compare.indexOf(base)
        if (indexOf !== -1) {
            return [
                {
                    wordsIndexBase: 0,
                    wordsIndexCompare: 0,
                    wordsBase: shortStr === "base" ? "" : base.slice(0, indexOf),
                    wordsCompare: shortStr === "compare" ? "" : compare.slice(0, indexOf),
                    diffType: "replace",
                },
                {
                    wordsIndexBase: shortStr === "base" ? base.length : indexOf + compare.length,
                    wordsIndexCompare: shortStr === "compare" ? compare.length : indexOf + base.length,
                    wordsBase: shortStr === "base" ? "" : base.slice(indexOf + compare.length, base.length),
                    wordsCompare: shortStr === "compare" ? "" : compare.slice(indexOf + base.length, compare.length),
                    diffType: "replace",
                },
            ]
        } else {
            let cutStr = shortStr === "base" ? compare.slice(0, base.length) : base.slice(0, compare.length)
            let extraStr =
                shortStr === "base"
                    ? compare.slice(base.length, compare.length)
                    : base.slice(compare.length, base.length)
            let diffwords = createDiffWords(
                shortStr === "base" ? base : cutStr,
                shortStr === "compare" ? compare : cutStr
            )
            diffwords.push({
                wordsIndexBase: shortStr === "base" ? base.length : compare.length,
                wordsIndexCompare: shortStr === "compare" ? compare.length : base.length,
                wordsBase: shortStr === "base" ? "" : extraStr,
                wordsCompare: shortStr === "compare" ? "" : extraStr,
                diffType: "replace",
            })
            return diffwords
        }
    }
}
const createDiffWords = (base: any, compare: any) => {
    let diffwords = []
    let startIndex = 0
    let status = false
    for (let i = 0; i < base.length; i++) {
        if (base[i] !== compare[i]) {
            if (!status) {
                status = true
                startIndex = i
            }
        } else {
            if (status) {
                status = false
                diffwords.push({
                    wordsIndexBase: startIndex,
                    wordsIndexCompare: startIndex,
                    wordsBase: base.slice(startIndex, i),
                    wordsCompare: compare.slice(startIndex, i),
                    diffType: "replace",
                })
            }
        }
    }
    if (status === true) {
        diffwords.push({
            wordsIndexBase: startIndex,
            wordsIndexCompare: startIndex,
            wordsBase: base.slice(startIndex, base.length),
            wordsCompare: compare.slice(startIndex, base.length),
            diffType: "replace",
        })
    }
    return diffwords
}

const ReplaceItem: React.FunctionComponent<ContentItemProps> = ({
    onJump,
    onHover,
    data,
    hoverItem,
    index,
    renderDiffWords,
}) => {
    const diffWords = calculateContent(data.contentBase, data.contentCompare)
    return (
        <div
            id={`contentItem${data.diffIndex}`}
            onMouseOver={() => onHover(data)}
            onClick={() => onJump(data)}
            key={data.diffIndex}
            style={getBorder(data, hoverItem, data.diffType)}
            className={classNames(Styles.contentItem, Styles.replaceItem)}
        >
            <div key={`replaceTitle${data.diffIndex}`} style={{color: "#276ff5"}} className={Styles.replaceItemNav}>
                修改内容
            </div>
            <div key={`replaceBody${data.diffIndex}`} className={Styles.replaceBox}>
                <div className={Styles.replaceItemBox}>
                    <div className={Styles.replaceItemText}>原文档：</div>
                    <div className={Styles.replaceItemMsg}>
                        {/* {renderDiffWords(data.contentBase, data.diffWords, "base")}*/}
                        {renderDiffWords(data.contentBase, diffWords, "base")}
                    </div>
                </div>
                <div className={Styles.replaceItemBox}>
                    <div className={Styles.replaceItemText}>比对文档：</div>
                    <div className={Styles.replaceItemMsg}>
                        {/* {renderDiffWords(data.contentCompare, data.diffWords, "compare")}*/}
                        {renderDiffWords(data.contentCompare, diffWords, "compare")}
                    </div>
                </div>
            </div>
        </div>
    )
}
const DeleteItem: React.FunctionComponent<ContentItemProps> = ({onJump, onHover, data, index, hoverItem}) => {
    return (
        <div
            id={`contentItem${data.diffIndex}`}
            onMouseOver={() => onHover(data)}
            onClick={() => onJump(data)}
            key={data.diffIndex}
            style={getBorder(data, hoverItem, data.diffType)}
            className={classNames(Styles.contentItem, Styles[`deleteItem`])}
        >
            <div
                key={`${data.diffType}Titles${data.diffIndex}`}
                style={{
                    color: "#ff991c",
                }}
                className={Styles.otherItemNav}
            >
                删除内容
            </div>
            <div key={`${data.diffType}Body${data.diffIndex}`} className={Styles.otherBox}>
                <div className={Styles.otherItem}>{data.contentBase}</div>
            </div>
        </div>
    )
}
const InsertItem: React.FunctionComponent<ContentItemProps> = ({onJump, onHover, data, index, hoverItem}) => {
    return (
        <div
            id={`contentItem${data.diffIndex}`}
            onMouseOver={() => onHover(data)}
            onClick={() => onJump(data)}
            key={data.diffIndex}
            style={getBorder(data, hoverItem, data.diffType)}
            className={classNames(Styles.contentItem, Styles[`insertItem`])}
        >
            <div
                key={`${data.diffType}Titles${data.diffIndex}`}
                style={{
                    color: "#0ca43e",
                }}
                className={Styles.otherItemNav}
            >
                新增内容
            </div>
            <div key={`${data.diffType}Body${data.diffIndex}`} className={Styles.otherBox}>
                <div className={Styles.otherItem}>{data.contentCompare}</div>
            </div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        pageJump: state.control.pageJump,
        shapeFromPos: state.data.shapeFromPos,
        hoverItem: state.data.hoverItem,
    }
})(DataList)
